export function getQueryKey(messenger: string, chatBotId: string): string {
    return `${messenger}_${chatBotId}`;
}
